import enLocale from 'element-ui/lib/locale/lang/en' //引入element语言包
const en = {
  LoginPage: {
    text1: 'Login to your account',
    text2: 'Email/phone number',
    text3: 'Enter the graphic code',
    text4: 'Password',
    text5: 'forget the password?',
    text6: 'Log in',
    text7: 'I have agreed and read the',
    text8: 'and',
    text9: 'User Agreement',
    text10: 'Privacy Policy',
    text11: 'or',
    text12: 'Register an account',
    text13: 'Prompt',
    text14: 'Read and agree',
    text15: 'Cancel',
    text16: 'Agree',
    text17: 'registered successfully',
    text18: 'Login succeeded',
    text19: 'Please enter a valid email/phone number',
    text20: 'Account password incorrect',
    text21: 'Please enter password',
    text22: 'Password length cannot be less than 8 characters',
    text23: 'Passwords must contain letters and numbers',
    text24: 'Password inconsistency',
  },
  RegisterPage: {
    text1: 'Registration',
    text2: 'Email/phone number',
    text3: 'Send verification code',
    text4: 'Password',
    text5: 'Confirm password again',
    text6: 'At least 8 digits, composed of letters and numbers',
    error1: 'Please enter a valid email/phone number',
    error2: 'Please enter the verification code',
    error3: 'Account password incorrect',
    text7: 'Verification code'
  },
  ResetPassword: {
    text1: 'Reset Password',
    text2: 'Confirm password again',
    text3: 'At least 8 digits, composed of letters and numbers',
    text4: 'Confirm',
    text5: 'Reset successful',
  },
  ForgotPassword: {
    text1: 'Retrieve Password',
    text2: 'Email/phone number',
    text3: 'Send verification code',
    text4: 'Next step',
    text5: 'Resend later',
    text6: 'Please enter a valid verification code',
  },
  HomePage: {
    headerText1: 'Homepage',
    headerText2: 'Text Translation',
    headerText3: 'Voice Translation',
    headerText4: 'AI Agent',
    headerText5: 'resource',
    buttonText1: 'Log in',
    buttonText2: 'Free Trial',
    langText1: 'Traditional Chinese',
    langText2: 'Simplified Chinese',
    langText3: 'English',
    resources1: 'API document',
    resources2: 'Explore our API document',
    resources3: 'Frequently Asked Questions',
    resources4: 'Problems and Solutions',
    resources5: 'Contact Us',
    resources6: 'Detailed consultation details',
    scheme1: 'Please select the appropriate plan',
    scheme2: 'Ultra-low prices, multi-language support, customized solutions, contact customer service',
    scheme3: 'Text Translation',
    scheme4: 'Voice Translation',
    scheme5: 'Document Translation',
    scheme6: 'Basic Edition',
    scheme7: '/Million characters',
    scheme8: 'Concurrency (qps)',
    scheme9: '5～1000(support expansion)',
    scheme10: 'Baidu Translate-Enterprise Edition',
    scheme11: 'Youdao Translation',
    scheme12: 'Volcano Translation',
    scheme13: 'yandex',
    scheme14: 'Learn more',
    scheme15: 'Premium',
    scheme16: 'DeepL- API PRO',
    scheme17: 'Google Translate- V2/V3',
    scheme18: 'Microsoft Translator',
    scheme19: 'Standard Edition',
    scheme20: 'ChatGPT translate',
    scheme21: 'Speech to Text Recognition',
    scheme22: '/hour',
    scheme23: '100 (supports extensions)',
    scheme24: 'Designated language voice translation',
    scheme25: 'Automatic recognition of language and speech translation',
    scheme26: 'DeepL Translation',
    num1: 25,
    num2: 60,
    num3: 50,
    num4: 3.6,
    num5: 9.1,
    num6: 10.2,
    num7: 90,
    num8: 5,
    fanyi1: 'Connect to the top translation engines to match your scenario needs',
    fanyi2: "Whether it is business documents, cross-border e-commerce or technical localization, we can accurately dispatch the best translation resources for you to achieve efficient, secure and low-cost global communication.",
    fanyi3: 'Text Translation',
    fanyi4: 'Voice Translation',
    fanyi5: 'Speech recognition',
    fanyi6: 'AI real-time translation, providing diversified solutions',
    fanyi7: '140+ language dialects · 400+ high-quality sounds · Choose as you like (free trial of interface)',
    intelligent1: "AI Agent: Your Super Assistant for the Digital World",
    intelligent2: 'Supports multi-dimensional communication through voice and text, providing real-time dialogue robots, writing assistants, and learning assistants to answer questions in various fields such as science, technology, history, culture, entertainment, etc.',
    intelligent3: 'Intelligent Assistant',
    intelligent4: 'Voice Dialogue',
    support1: 'Advantages of choosing us',
    support2: 'Certification technical support',
    support3: "Our senior AI voice technology team provides Microsoft TTS/STT full-stack solutions to enable efficient implementation of enterprise-level voice interaction and unleash the commercial value of intelligent voice!",
    support4: 'Comprehensive agency service provider',
    support5: 'Aggregate multiple leading technology service providers to provide the best technology combination solutions, diversified resource integration capabilities and professional services, which can create significant value for corporate customers',
    support6: 'Advantage channel price',
    support7: 'We are a comprehensive agent service provider of mainstream translation engines, bringing together many corporate customers. We can provide advantageous channel prices',
    footer1: 'Make an appointment with your exclusive solution consultant to obtain a customized pricing solution',
    footer2: 'Please enter your name',
    footer3: 'Please enter your phone number',
    footer4: 'Appointment',
    footer5: 'Appointment successful, please pay attention to your call information',
    footer6: 'about Us：',
    footer7: 'XRION TECHNOLOGY LIMITED',
    footer8: 'Mail：admin@xrion.ai',
    footer9: 'Telephone：+852 4640 4336',
    footer10: 'Translation',
    footer11: 'AI Big Model',
    footer12: 'Resources',
    footer13: 'Text Translation',
    footer14: 'AI intelligent agent',
    footer15: 'API Document',
    footer16: 'Voice Translation',
    footer17: 'Frequently Asked Questions',
    footer18: 'Port ICP No. 8384773838282-1',
    expect: 'Stay tuned',
    text1: 'Hong Kong Mobile Number',
    text2: 'AI Cool Download',
    text3: 'User Agreement',
    text4: 'Privacy Policy',
    text5: 'Payment Agreement',
    text6: 'go back',
    text7:'Original price:'
  },
  TextTranslation: {
    text1: 'Console',
    text2: 'Log out',
    text3: 'Automatic detection',
    text4: 'Input text, automatic translation...',
    text5: 'Language search',
    text6: 'Detect Language',
    text7: 'Search Language',
    text8: 'Please select the target language',
    text9: 'Please log in first',
  },
  VoicePage: {
    text1: 'Voice translation',
    text2: 'Speech recognition',
    text3: 'Targeted Translation',
    text4: 'Only display translation target language',
    text5: 'Bi directional translation',
    text6: 'Automatic recognition of bilingual translation',
    text7: 'Enter language:',
    text8: 'Recognition result (maximum support for single recognition is 1 minute)',
    text9: 'Insufficient translation balance, please recharge first',
    text10: 'Cancel',
    text11: 'Go recharge',
    text12: 'Chinese (Mandarin, Simplified)',
    text13: 'English (USA)',
    text14: 'This displays the target language translation result...',
    text15: 'The speech recognition results are displayed here...'
  },
  ConsolePanel: {
    text1: "translation key",
    text2: "Copy",
    text3: "View API Key",
    text4: "top up",
    text5: "Tip: 1.If you have any usage problems or need invoice assistance, please contact customer service",
    text6: "Using Statistical Charts",
    text7: "Last 7 days",
    text8: "Last 15days",
    text9: "Last 30 days",
    text10: "Copy successful",
    text11: "Usage Details",
    text12: "operate",
    text13: "Translation Engine",
    text14: "Price (million characters)",
    text15: "Number of characters used",
    text16: "characters left",
    text17: "View API public key",
    text18: "character",
    text19: "2. The exchange rate is updated daily, and the actual payment amount may be slightly adjusted due to exchange rate fluctuations",
    text20: "currency:",
    text21: "DeepL",
    text22: "Google Translate",
    text23: "Microsoft Translator",
    text24: "Baidu Translate-Enterprise Edition",
    text25: "Youdao Translation",
    text26: "Volcano Translation",
    text27: "chatGPT Translation",
    text28: "yandex",
    text29:'Service Type',
    text30:'Original price (hour)',
    text31:'Limited time discount price (hours)',
    text32:'Elapsed time',
    text33:'Expenses consumed ',
    text34:'Remaining amount',
    text35: 'Speech-to-text recognition',
    text36: 'Specify language voice translation',
    text37: 'Automatic language recognition and voice translation',
    text38: 'Original price (million characters)',
    text39: 'Discounted price (yuan/million characters)',
    text40:'RMB',
    text41:'USD',
    text42:'Cost'
  },
  PayPage: {
    text1: 'Recharge Order',
    text2: 'Service Information',
    text3: 'user id',
    text4: 'Recharge Products',
    text5: 'Translation Engine',
    text6: 'Recharge Character Quantity',
    text7: 'million',
    text8: 'price',
    text9: '/million characters',
    text10: 'total',
    text11: 'Payment Methods',
    text12: 'I have read and agreed to the',
    text13: '"XRION Service Payment Agreement"',
    text14: 'Pay',
    text15: 'Insufficient number of translated characters, please recharge first',
    text16: 'Submit Order',
    text17: 'Confirm payment',
    text18: 'Payment successful',
    text19: 'Payment failed',
    text20: 'WeChat Pay',
    text21: 'Alipay',
    text22: 'Balance',
    text23: 'Recharge Amount',
    text24:'$'
  },
  OrderPage:{
    Text1:  'Amount to be paid:',
    Text2:  'Please complete the payment before the countdown of',
    Text3:  'minutes and',
    Text4:  'seconds',
    Text5:  'otherwise the order will be automatically cancelled',
    Text6:  'Open Alipay on your phone',
    Text7:  'Open WeChat Pay on your phone',
    Text8:  'and scan to continue payment',
    Text9:  'Timeout',
    Text10: 'The order has timed out, please return to the console and resubmit the order',
    Text11: 'Payment successful',
    Text12: 'Payment timeout',
    Text13: 'Leaving means you are abandoning payment for this order. Confirm to leave?',
    Text14: "Your payment has not been completed yet. Please do not leave the current interface!'! ",
    Text15: 'Confirm',
    Text16: 'Cancel',
  },
  StripePay: {
    text1: 'Order submitted successfully, payment order number:',
    text2: 'Order information:',
    text3: 'Million characters',
    text4: 'Payment amount:',
    text5: 'Recharge of voice translation balance'
  },
  PayResult: {
    text1: 'Return to Console',
  },
  IntelligentAgent: {
    Text1: 'Search History',
    Text2: 'Delete',
    Text3: 'Hi！ I am your intelligent assistant',
    Text4: 'Enter your feedback and suggestions~',
    Text5: 'Submit',
    Text6: 'Enter your question...',
    Text7: 'Delete conversation',
    Text8: 'After deletion, the conversation cannot be restored. Are you sure to delete?',
    Text9: 'Cancel',
    Text10: 'Fold up the sidebar',
    Text11: 'Expand',
  },
  FAQPage: {
    Title:'Frequently Asked Questions',
    Question1: 'Q1. How does XRION serve its customers?',
    Text1: 'We are an aggregator translation service provider that aggregates mainstream translation company interfaces to provide cheaper and more diverse translation services.',
    Question2: 'Q2. What translation engines are currently available?',
    Text2: 'DeepL、 Google, Baidu, Youdao Translation, Microsoft, Volcano Translation OpenAI、YanDex。',
    Question3: 'Q3.How is the cost charged for translating characters? ',
    Text3: "Calculate your usage by character count.'.The calculated characters are the number of characters in the source text, which is the original text you want to translate.One character corresponds to a code point encoded in UTF- 8, meaning that one Chinese character or English letter is counted as one character.The final billing character count is obtained by multiplying the number of characters translated by the billing rate corresponding to the translation service used and rounding it up. ",
    Question4: 'Q4.Can I open a value- added tax invoice? ',
    Text4: "Okay.Contact customer service to issue a value - added tax invoice.If you need to issue an invoice, you need to make an appointment in advance. ",
    Question5: 'Q5.Will my translation request be stored ? ',
    Text5: "Do not store any text or its translation results that you request.'.Only metadata related to the request(time of request and number of translated characters) will be saved for billing and statistical purposes. ",
    Question6: 'Q6.Is there a risk of leakage for my translation source text and translation results ? ',
    Text6: "We will never store your translation source text and translation results, however, we cannot guarantee the data storage rules of upstream services.'.Please refer to the privacy policy of the corresponding service when using different services to avoid risks. ",
},
errorMsg1:"Currently being identified, please wait a moment...",
  ...enLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
export default en;
